import {ImportResiComponent} from './import-resi.component'

export default ImportResiComponent